var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyRepayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 783252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2334 3H0V48.4922H46C46.2078 46.1608 45.2821 46.5898 47 45C48.7179 43.4102 45.8593 42.4268 48.1998 42.4L48.2334 3Z",
    fill: "#7256CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0083 30.2441V67.7479L54.775 64.0109H54.9428H55.0995L88.8774 67.7479V30.2441L55.1219 34.5069H54.9428H54.7526L21.0083 30.2441Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.9433 58.081C59.8311 58.081 63.7934 54.1187 63.7934 49.2309C63.7934 44.3432 59.8311 40.3809 54.9433 40.3809C50.0556 40.3809 46.0933 44.3432 46.0933 49.2309C46.0933 54.1187 50.0556 58.081 54.9433 58.081Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.0774 26.6076V3M46.5742 18.0037L55.0774 26.6076L46.5742 18.0037ZM55.0774 26.6076L63.782 18.0037L55.0774 26.6076Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.29 69.3926V93.0003M63.7932 77.9854L55.29 69.3926L63.7932 77.9854ZM55.29 69.3926L46.5854 77.9854L55.29 69.3926Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M46.7085 77.9965L55.3124 69.3926L63.8492 77.9294",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M63.6588 18.0596L55.0549 26.6635L46.5181 18.1267",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyRepayment);
export default __webpack_public_path__ + "static/media/easy_repayment.61caeb97fadd337604562b88ce4df602.svg";
export { ForwardRef as ReactComponent };